import { StripeProvider } from '@stripe/stripe-react-native';
import { env } from 'app/lib/env';
import { isWhiteLabel } from 'app/utils/helpers';
import { isMobileNative } from 'app/utils/web-helpers';
import type { ReactElement } from 'react';

export function StripeProviderLPC({ children }: { children: ReactElement | ReactElement[] }) {
  if (isMobileNative) {
    return (
      <StripeProvider
        merchantIdentifier={isWhiteLabel() ? undefined : env.APPLE_PAY_MERCHANT_ID}
        publishableKey={env.STRIPE_PUBLISHABLE_KEY}
        urlScheme="partageclub"
      >
        {children}
      </StripeProvider>
    );
  }
  return children;
}
